import styled, { css } from 'styled-components';
import { BaseText, TextBlock } from '../text';
import { FontSize14, FontFamilyMedium, FontSize16 } from '../fonts';
import { MarginTop8 } from '../margins';

export const BooleanInputHidden = styled.input`
    display: none;
`;

export const LabelSpacer = styled.span`
    margin-left: 10px;
    color: ${props => props.theme.color.darkBlue};
    ${props => props.isLabelBold && css`
        ${FontFamilyMedium};
        ${FontSize16};
    `};
`;

export const BooleanInputContainer = styled.div`
    position: relative;
    width: ${props => props.isSmall ? '20px' : '24px'};
    height: ${props => props.isSmall ? '20px' : '24px'};
`;

export const BooleanInput = styled.div`
    position: relative;
    width: ${props => props.isSmall ? '20px' : '24px'};
    height: ${props => props.isSmall ? '20px' : '24px'};
    border-radius: ${props => props.isCircle ? '15px': '0px'};
    border: solid 2px ${props => props.theme.color.darkBlue};
`;

export const BooleanInputGreenCircle = styled.div`
    position: absolute;
    width: ${props => props.isSmall ? '12px' : '16px'};
    height: ${props => props.isSmall ? '12px' : '16px'};
    border-radius: ${props => props.isCircle ? '15px': '0px'};
    background-color: ${props => props.theme.color.green};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) ${props => props.isVisible ? 'scale(1)' : 'scale(0)'};
    transition: transform 0.2s ease-in-out;

`;

export const BooleanButtonLabel = styled.label`
    ${BaseText};
    ${FontSize14};
    display: flex;
    line-height: 24px;
    width: 100%;
`;

export const BooleanInputErrorText = styled(TextBlock)`
    color: ${props => props.theme.color.red};
    ${FontSize14};
    ${MarginTop8};
`;